import { BadgeV3 } from '@cimplico/components';
import { usePriorInvoices } from '../../../../queries/billing/use-prior-invoices';
import { formatDate } from '../../../../utilities/formatting';
import LoadingCell from './LoadingCell';

function HistorySection(): JSX.Element {
    const query = usePriorInvoices();
    const invoices = query.data?.invoices ?? [];
    return (
        <div className="flex gap-16 flex-wrap">
            <div className="w-[400px]">
                <h3 className="text-contentPrimary font-bold">History</h3>
                <p className="text-sm text-contentSecondary mt-1">
                    See your past invoices, including dates, totals, and downloadable copies for your records.
                </p>
            </div>
            <div className="flex-1">
                <p className="text-contentPrimary text-sm font-bold">Invoices (Last 5)</p>
                <table className="w-full mt-8">
                    <thead>
                        <tr className="border-b">
                            <th className="text-contentPrimary text-xs font-bold uppercase text-left pb-2">Date</th>
                            <th className="text-contentPrimary text-xs font-bold uppercase text-left pb-2"># Number</th>
                            <th className="text-contentPrimary text-xs font-bold uppercase text-right pb-2">Total</th>
                            <th className="text-contentPrimary text-xs font-bold uppercase text-center pb-2"></th>
                        </tr>
                    </thead>

                    <tbody>
                        {query.isLoading && (
                            <>
                                <tr>
                                    <LoadingCell colSpan={4} />
                                </tr>
                                <tr>
                                    <LoadingCell colSpan={4} />
                                </tr>
                                <tr>
                                    <LoadingCell colSpan={4} />
                                </tr>
                                <tr>
                                    <LoadingCell colSpan={4} />
                                </tr>
                                <tr>
                                    <LoadingCell colSpan={4} />
                                </tr>
                            </>
                        )}
                        {invoices.map((invoice) => (
                            <tr key={invoice.id} className="border-b">
                                <td className="text-contentSecondary text-sm py-2">
                                    <div className="flex items-center gap-2">
                                        <p className="w-[100px]">{formatDate(invoice.date)}</p>
                                        {invoice.status === 'paid' && (
                                            <span className="shrink-0">
                                                <BadgeV3 label="Paid" color="green" />
                                            </span>
                                        )}
                                    </div>
                                </td>
                                <td className="text-contentSecondary text-sm py-2">{invoice.number}</td>
                                <td className="text-contentSecondary text-sm py-2 text-right">
                                    {new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'aud',
                                    }).format(invoice.amount / 100)}
                                </td>
                                <td>
                                    <div className="py-2 text-center">
                                        <a
                                            href={invoice.pdf}
                                            className="shadow-sm rounded-md border bg-white py-1.5 px-2.5 text-xs text-contentPrimary"
                                            target={'_blank'}
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default HistorySection;
